import React from "react";
// @material-ui/core components
import {makeStyles, withStyles} from "@material-ui/core/styles";
// @material-ui/icons
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";

import BaseHeader from "./BaseView/BaseHeader";
import Parallax from "../components/Parallax/Parallax";
import BaseFooter from "./BaseView/BaseFooter";
import {getUserOrderInfo, getUserPlans} from "../utils/request";
import storage from "../utils/storage";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import intl from "react-intl-universal";


function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class Plans2 extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			// plansSeries: [],
			userLogin: !(storage.get('token') === null || storage.get('token') === undefined),
			inNewQuery: true,
			isVip: false,
			blockDate: "2020-12-31"
		};

		document.title = intl.get('subscription') + " - RobinAlgo";

		this.initDate()
	}

	initDate = () => {
		getUserPlans(this.state.userLogin).then(res => {
			this.setState({
				plansSeries: res.data
			})
		})
	};

	userOrderInfo = () => {
		this.setState({
			inNewQuery: false
		});
		getUserOrderInfo().then(res => {
			this.setState({
				inNewQuery: true,
			}, () => {
				this.initDate()
			});

		})
	};

	render() {

		const {classes} = this.props;


		return (
			<div>
				<BaseHeader fixed/>

				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/plan_bg.jpg"}
						  filter="dark" small>


					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h1 className={classes.title} style={{color: "white"}}>
									{intl.get('title_plan')}
								</h1>
							</GridItem>
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h4 className={classes.title} style={{color: "white"}}>
									{intl.get('plan_info')}
								</h4>
							</GridItem>
						</GridContainer>
					</div>
				</Parallax>


				<div className={classes.main}>
					<div className={classes.container}>

						{this.state.userLogin ?

							<GridContainer justify="flex-end"
										   alignItems="center">

								<h4 style={{color: "#ff9800", zIndex: '1000'}}>
									{intl.get('plan_success')}
								</h4>
								<Button
									color="rose"
									onClick={this.userOrderInfo}
									style={{marginLeft: '12px', minWidth: '180px'}}
									disable={!this.state.inNewQuery}
								>

									{
										!this.state.inNewQuery ?
											<CircularProgress
												style={{width: '100%', height: '100%'}}
												color={'#fff'}/>
											:
											<span>{intl.get('order_plan')}</span>
									}


								</Button>
							</GridContainer>
							:
							null
						}

						<GridContainer justify="center">
							<GridItem xs={12} sm={6} md={6} lg={4} style={{marginTop: '24px'}}>
								<Card
									pricing
									// background
									// style={{backgroundImage: `url(${cardBlog3})`}}
								>

									<CardBody>

										<h3 className={classes.cardTitleWhite}>
											<b>普通用户</b>
										</h3>

										<h2>
											<small><small>¥</small></small>&nbsp;<b>0</b>
										</h2>

										<Button href={"/series_info/1"} style={{width: '100%', fontSize: '14pt'}}
												color={"primary"}>
											立即使用
										</Button>

										{/*<Divider/>*/}
										<GridContainer justify="flex-start"
													   style={{marginTop: '16px'}}>
											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959',
														textAlgin: 'left'
													}}>4个完整的试看视频</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>完整的题目可视化动画展示</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>相关代码及内容的查看</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>
										</GridContainer>

									</CardBody>
								</Card>
							</GridItem>

							<GridItem xs={12} sm={6} md={6} lg={4} style={{marginTop: '24px'}}>
								<Card
									pricing
									// background
									// style={{backgroundImage: `url(${cardBlog3})`}}
								>

									<CardBody>

										<h3 className={classes.cardTitleWhite}>
											<b>RobinAlgo会员</b>
										</h3>

										<h2>
											<small><small><small>低至</small></small></small><small><small>¥&nbsp;</small></small><b>0.49</b><small><small><small>&nbsp;/每天</small></small></small>
										</h2>

										<Button href={"/create_pay"} style={{width: '100%', fontSize: '14pt'}}
												color={"rose"} >
											{this.state.isVip ? <span>续费订阅</span>: <span>即刻升级</span>}

										</Button>

										{/*<Divider/>*/}
										<GridContainer justify="flex-start"
													   style={{marginTop: '16px'}}>
											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959',
														textAlgin: 'left'
													}}>100+完整的视频观看</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>完整的题目可视化动画展示</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>相关代码及内容的查看</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>黑板手绘展示题目讲解思路</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>

											<GridItem xs={10} sm={10} md={10} lg={10}
													  style={{marginTop: '8px'}}>
												<b
													style={{
														fontSize: '12pt',
														color: '#595959'
													}}>每行代码详细注释解答</b>
											</GridItem>
											<GridItem xs={1} sm={1} md={1} lg={1}
													  style={{marginTop: '8px'}}>
												<Check color={"secondary"}/>
											</GridItem>
										</GridContainer>

									</CardBody>
								</Card>
							</GridItem>
						</GridContainer>
					</div>
				</div>

				<BaseFooter/>
			</div>
		);
	}
}

export default withStyles(blogPostPageStyle)(Plans2)